// Información de build generada automáticamente
export const BUILD_DATE = '30-09-2026 18:27:10';
export const BUILD_HASH = 'r5l347295zi';
export const APP_VERSION = '0.0.0';
export const BUILD_TIMESTAMP = 1790803630830;

// Para debugging en consola
console.log('%cℹ️ Build Info', 'color: #2196F3; font-weight: bold;', {
  buildDate: '30-09-2026 18:27:10',
  buildHash: 'r5l347295zi',
  appVersion: '0.0.0',
  timestamp: 1790803630830
});
